import { Box, styled } from '@mui/material';

export const AccordionLabel = styled(Box)(
  () => `
          width: 100%; 
          padding-right: 5px;
          display: flex; 
          justify-content: space-between;
  `,
);
